import { render } from "./SearchForm.vue?vue&type=template&id=0cf7f504&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=0cf7f504&scoped=true&lang=css"
import "./SearchForm.vue?vue&type=style&index=1&id=0cf7f504&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf7f504"]])

export default __exports__